const EventPage = '/studio-director/teams/:teamId/events/:eventId',
  BroadcastPage = `${EventPage}/broadcasts/:broadcastId`,
  HeadlessStressTestPage = `${BroadcastPage}/headlessStressTest`,
  ScenePreview = `${BroadcastPage}/scene/:sceneId`,
  JoinPage = `${BroadcastPage}/join`;

const AppPaths = {
  EventPage,
  BroadcastPage,
  HeadlessStressTestPage,
  ScenePreview,
  JoinPage
};

export default AppPaths;
